import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useWarehouseReducer = () => useSelector((state: ApplicationState) => state.warehouse);
